import {
  FaBoxes,
  FaBroom,
  FaTruck,
  FaUsers,
} from "react-icons/fa";

const stats = [
  {
    icon: <FaBoxes />,
    title: "Multi-category supply",
    text: "From children products to office equipment, furniture, appliances, and consumables.",
  },
  {
    icon: <FaBroom />,
    title: "Cleaning excellence",
    text: "Residential and deep cleaning handled with care, consistency, and attention to detail.",
  },
  {
    icon: <FaTruck />,
    title: "Timely delivery",
    text: "We focus on responsive logistics so customers receive the products and support they need on time.",
  },
  {
    icon: <FaUsers />,
    title: "Business-led team",
    text: "A trusted leadership team with strengths in business administration, procurement, and accounts.",
  },
];

export default function HomeStats() {
  return (
    <section className="section-shell">
      <div className="container">
        <div className="row g-4">
          {stats.map((stat, index) => (
            <div key={stat.title} className="col-md-6 col-xl-3">
              <div className="info-card h-100" data-aos="fade-up" data-aos-delay={index * 150}>
                <div className="info-card-icon">{stat.icon}</div>
                <h3>{stat.title}</h3>
                <p>{stat.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
